import React, { useState, useEffect, useRef } from 'react';
import { LoadScript, Autocomplete } from '@react-google-maps/api';
import './Chatbot.css';


 const API_URL ='https://ai-sales-agent-two.vercel.app';

console.log('Using API:', API_URL);

const GOOGLE_MAPS_API_KEY = 'AIzaSyClxf9DdZdCAjNqTgm3vizgIsN3jwO0U-4';



export default function Chatbot() {
  
  // const navigate = useNavigate();
  const [messages, setMessages] = useState([
    { from: "bot", text: "Hi! I'm Bvumbi-Bot. How can I help you today?" }
  ]);
  const [showContactForm, setShowContactForm] = useState(false);
  const [showPriceCalculator, setShowPriceCalculator] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isCompany, setIsCompany] = useState(false);
  const [autocomplete, setAutocomplete] = useState(null);
  const [mapLoaded, setMapLoaded] = useState(false);
  const [isCalculating, setIsCalculating] = useState(false);
  const [addressInput, setAddressInput] = useState('');
  /******************************************************************************/
  const [showFAQ, setShowFAQ] = useState(false);
  const [faqItems, setFaqItems] = useState([]);

  const [awaitingAcceptance, setAwaitingAcceptance] = useState(false);
  const [currentQuoteData, setCurrentQuoteData] = useState(null);


  const [contact, setContact] = useState({
    firstName: "",
    surname: "",
    email: "",
    whatsapp: "",
    projectDetails: "",
    companyName: "",
    companyRegNumber: "",
    physicalAddress: "",
    strength: "25 MPa",
    concreteType: "Standard",
    needsPump: false,
    site: "a",
    deliveryAddress: "",
    deliveryDistance: 0,
    deliveryFee: 0
  });

  const [calculation, setCalculation] = useState({
    strength: "25 MPa",
    type: "Standard",
    quantity: "1",
    site: "a",
    deliveryAddress: "",
    deliveryFee: 0,
    deliveryDistance: 0,
    needsPump: false // Add this line
  });

  const messagesEndRef = useRef(null);
  const inputRef = useRef(null);

  const strengthOptions = ["10 MPa", "15 MPa", "20 MPa", "25 MPa", "30 MPa", "35 MPa", "40 MPa", "45 MPa", "50 MPa"];
  const concreteTypes = ["Standard", "Pumpable"];
  const siteOptions = [
    { id: "a", name: "Atterbury" },
    { id: "r", name: "Rosslyn" },
    { id: "w", name: "Vaalwater" },
    { id: "v", name: "kwamhlanga" }
  ];

  const onPlaceChanged = () => {
    if (autocomplete !== null) {
      const place = autocomplete.getPlace();
      if (!place.geometry) return;
      const formattedAddress = place.formatted_address;
      setCalculation(prev => ({ ...prev, deliveryAddress: formattedAddress }));
      setAddressInput(formattedAddress);
    }
  };


  const generateQuoteNumber = () => {
    const now = new Date();
    const datePart = now.toISOString().slice(2, 10).replace(/-/g, '');
    const randomPart = Math.floor(1000 + Math.random() * 9000);
    return `Q-${datePart}-${randomPart}`;
  };

  const handleAddressSubmit = async () => {
    if (!calculation.deliveryAddress) {
      setMessages(msgs => [...msgs, {
        from: "bot",
        text: "Please enter a delivery address first."
      }]);
      return;
    }

    setIsCalculating(true);
    const quoteNumber = generateQuoteNumber();

    try {
      console.log('Submitting with pump selection:', {
        needsPump: calculation.needsPump,
        type: calculation.type
      });

      // 1. Find nearest site
      const nearestSiteResponse = await fetch(`${API_URL}/find-nearest-site`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ address: calculation.deliveryAddress })
      });

      if (!nearestSiteResponse.ok) {
        throw new Error(`HTTP error! status: ${nearestSiteResponse.status}`);
      }

      const siteData = await nearestSiteResponse.json();

      // 2. Calculate price with explicit pump data
      const pricePayload = {
        siteCode: siteData.nearestSite.siteCode,
        strength: calculation.strength.replace(' MPa', ''),
        type: calculation.type,
        quantity: calculation.quantity,
        needsPump: calculation.needsPump,
        deliveryDistance: siteData.deliveryDistance,
        address: calculation.deliveryAddress
      };

      console.log('Price calculation payload:', pricePayload);

     const priceResponse = await fetch(`${API_URL}/calculate-price`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(pricePayload)
      });

      const priceData = await priceResponse.json();
      console.log('Price calculation response:', priceData);

      if (!priceData.success) {
        throw new Error(priceData.error || 'Price calculation failed');
      }


      // 3. Format and display the price
      const priceResult = formatPriceResponse({
        ...priceData.calculation,
        needsPump: calculation.needsPump
      });

      setMessages(msgs => [...msgs, {
        from: "bot",
        text: priceResult
      }]);

      // 4. Prepare data for email
      const emailData = {
        formData: {
          ...contact,
          deliveryAddress: calculation.deliveryAddress,
          strength: calculation.strength,
          concreteType: calculation.type,
          needsPump: calculation.needsPump,
          quantity: calculation.quantity,
          quoteNumber: quoteNumber,
        },
        calculationResult: {
          ...priceData,
          quoteNumber: quoteNumber
        }
      };

      // 5. Send email with quote
      const emailResponse = await fetch(`${API_URL}/chat`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(emailData)
      });

      const emailResult = await emailResponse.json();

      if (emailResult.reply) {
        setMessages(msgs => [...msgs, {
          from: "bot",
          text: emailResult.reply
        }]);
      }
      setContact(prev => ({
        ...prev,
        ...calculation,
        deliveryAddress: calculation.deliveryAddress, // Add this line
        deliveryFee: priceData.calculation.deliveryFee,
        deliveryDistance: priceData.calculation.deliveryDistance,
        pumpEstablishmentFee: priceData.calculation.pumpFees?.establishment || 0,
        pumpPerCubicFee: priceData.calculation.pumpFees?.perCubic || 0,
        needsPump: calculation.needsPump
      }));

      setShowPriceCalculator(false);
      setShowContactForm(false);
      setCurrentQuoteData({
        formData: { ...contact, deliveryAddress: calculation.deliveryAddress, quoteNumber },
        calculationResult: priceData
      });

      setMessages(msgs => [...msgs, {
        from: "bot",
        text: `We've sent the quote (${quoteNumber}) to your email. Would you like to accept this quote? (Yes/No)`
      }]);

      setAwaitingAcceptance(true);
      setShowPriceCalculator(false);

    } catch (error) {
      console.error("Calculation error:", error);
      setMessages(msgs => [...msgs, {
        from: "bot",
        text: error.message || "Failed to calculate. Please try again.Please contact:+27 12 004 3499"
      }]);
    } finally {
      setIsCalculating(false);
    }

  };


  const formatPriceResponse = (data) => {
    const subtotal = Number(data.subtotal || 0);
    const vat = Number(data.vat || 0);
    const pumpFee = Number(data.pumpFees?.total || 0); // Changed to use pumpFees.total
    const deliveryFee = Number(data.deliveryFee || 0);
    const total = Number(data.total || 0);

    // Determine pump status text
    const pumpStatus = data.needsPump ? "Yes" : "No";

    return `
    <strong>PRICE CALCULATION</strong><br/>
    • Mix Code: ${data.mixCode}<br/>
    • Strength: ${data.strength} MPa<br/>
    • Type: ${data.type}<br/>
    • Quantity: ${data.quantity} m³<br/>
    • Unit Price: R${Number(data.unitPrice).toFixed(2)}/m³<br/>
    • Subtotal: R${subtotal.toFixed(2)}<br/>
    • VAT: R${vat.toFixed(2)}<br/>
      ${data.needsPump ? `
      <strong>Pump Information:</strong><br/>
      • Pump Required: ${pumpStatus}<br/>

      • Total Pumping Fee: R${pumpFee.toFixed(2)}<br/>
    ` : ''}
    <strong>Delivery Information:</strong><br/>
    • Delivery Distance: ${Number(data.deliveryDistance).toFixed(2)} km<br/>
    • Delivery Fee: R${deliveryFee.toFixed(2)}<br/>
    <strong>TOTAL: R${total.toFixed(2)}</strong><br/><br/>
    <span style="color: #666;">${data.note || ''}</span>
     <span style="color: #666;">Disclaimer: The prices listed are estimates only and are provided for general informational purposes. Actual costs may vary depending on factors such as location, time of purchase, supplier pricing, availability, taxes, and applicable discounts. These figures should not be considered as final quotations or contractual offers. For precise pricing, please contact the relevant vendor or service provider directly.</span>
  `;
  };

  const handleSend = async (userMessage) => {

    setIsLoading(true);
    setMessages(msgs => [...msgs, { from: "user", text: userMessage }]);
    const trimmedMessage = userMessage.trim().toLowerCase();

    // Handle price calculator trigger
    if (["calculate", "price", "calculator", "quote"].some(keyword => trimmedMessage.includes(keyword))) {
      // First ask for contact info
      setMessages(msgs => [...msgs, {
        from: "bot",
        text: "Before we calculate the quote, please provide your contact details."
      }]);

      setShowContactForm(true);
      setIsLoading(false);
      return;
    }

    if (userMessage === "Submitted contact form") {
      // After contact form is submitted, now allow calculator
      setMessages(msgs => [...msgs, {
        from: "bot",
        text: "Thanks! Now let's calculate your quote."
      }]);

      setShowContactForm(false);
      setShowPriceCalculator(true);
      setIsLoading(false);
      return;
    }

    if (trimmedMessage.toLowerCase() === "admin@brmc004") {
      // Use React Router's navigation if available, or window.location as fallback
      if (window.ReactRouter && window.ReactRouter.useNavigate) {
        const navigate = window.ReactRouter.useNavigate();
        navigate('/UpdateSitePrices');
      } else {
        window.location.pathname = '/UpdateSitePrices';
      }
      return;
    }

    // Handle quote acceptance
    if (awaitingAcceptance) {
      if (trimmedMessage === 'yes' || trimmedMessage === 'no') {
        const accepted = trimmedMessage === 'yes';

        // Send acceptance email
        const acceptanceData = {
          ...currentQuoteData,
          accepted: accepted,
          acceptanceDate: new Date().toISOString()
        };

        const acceptanceResponse = await fetch(`${API_URL}/accept-quote`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(acceptanceData)
        });

        if (acceptanceResponse.ok) {
          setMessages(msgs => [...msgs, {
            from: "bot",
            text: accepted
              ? "Thank you for accepting the quote! We'll contact you shortly to confirm your order."
              : "We've noted your decision. Feel free to request a new quote anytime."
          }]);
        } else {
          setMessages(msgs => [...msgs, {
            from: "bot",
            text: "Failed to record your decision. Please contact us directly."
          }]);
        }

        setAwaitingAcceptance(false);
        return;
      }
    }


    if (showContactForm) {
      try {
        const quoteNumber = generateQuoteNumber();
        console.log('Submitting contact data:', contact);


        if (!contact.firstName || !contact.surname || !contact.email || !contact.whatsapp) {
          throw new Error('Please fill in all required fields: First Name, Surname, Email, and WhatsApp');
        }


        const calculationPayload = {
          siteCode: contact.site,
          strength: (contact.strength).replace(' MPa', ''),
          type: contact.concreteType || 'Standard',
          quantity: "1",
          needsPump: contact.needsPump || false,
          deliveryDistance: contact.deliveryDistance || 0
        };


        console.log('Calculation payload:', calculationPayload);


        const calculationResponse = await fetch(`${API_URL}/calculate-price`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(calculationPayload)
        });


        const contentType = calculationResponse.headers.get('content-type');

        if (!contentType || !contentType.includes('application/json')) {
          const text = await calculationResponse.text();
          console.error('Non-JSON response from calculate-price:', text);
          throw new Error('Server returned an unexpected response format');
        }

        const calculationData = await calculationResponse.json();
        console.log('Calculation response:', calculationData);

        if (!calculationData.success) {
          throw new Error(calculationData.error || 'Price calculation failed');
        }

        // 4. Prepare submission data
        const submissionData = {
          formData: {
            ...contact,
            name: `${contact.firstName} ${contact.surname}`,
            companyName: contact.companyName || undefined, // Clean up empty values
            companyRegNumber: contact.companyRegNumber || undefined,
            quoteNumber: quoteNumber
          },
          calculationResult: { calculationData }
        };

        // Debug: Log submission data
        console.log('Submission data:', submissionData);

        // 5. Send to chat endpoint
        const res = await fetch(`${API_URL}/chat`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(submissionData)
        });

        // Check for HTML responses
        const resContentType = res.headers.get('content-type');
        if (!resContentType || !resContentType.includes('application/json')) {
          const text = await res.text();
          console.error('Non-JSON response from chat endpoint:', text);
          throw new Error('Server returned an unexpected response');
        }

        const responseData = await res.json();
        console.log('Chat endpoint response:', responseData);

        if (!res.ok) {
          throw new Error(responseData.error || 'Submission failed');
        }

        // 6. Update UI
        setMessages(msgs => [...msgs, {
          from: "bot",
          text: responseData.reply || "Thank you! Your request has been submitted."
        }]);
        setShowContactForm(false);

        // 7. Reset form if needed
        setContact({
          firstName: "",
          surname: "",
          email: "",
          whatsapp: "",
          projectDetails: "",
          companyName: "",
          companyRegNumber: "",
          physicalAddress: "",
          strength: "25 MPa",
          concreteType: "Standard",
          needsPump: false,
          site: "a",
          deliveryAddress: "",
          deliveryDistance: 0,
          deliveryFee: 0
        });


      } catch (error) {
        console.error("Submission error:", error);
        setMessages(msgs => [...msgs, {
          from: "bot",
          text: error.message || "Failed to submit your request. Please try again later."
        }]);

        // Debug: Show error details in console
        if (error.response) {
          console.error('Error response:', error.response);
        }
      } finally {
        setIsLoading(false);
      }
      return;
    }

    // Handle regular chat messages
    try {
      const res = await fetch(`${API_URL}/chat`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message: userMessage }),
      });

      // Check for JSON response
      const contentType = res.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        const text = await res.text();
        console.error('Non-JSON chat response:', text);
        throw new Error('Unexpected server response');
      }

      const data = await res.json();
      console.log('Regular chat response:', data);

      // Auto-show contact form if response suggests pricing
      if (data.reply?.toLowerCase().match(/\b(cost|quote|price|pricing)\b/)) {
        setShowContactForm(true);
      }

      setMessages(msgs => [...msgs, { from: "bot", text: data.reply }]);
    } catch (error) {
      console.error("Chat error:", error);
      setMessages(msgs => [...msgs, {
        from: "bot",
        text: "We're having connection issues. Please try again shortly."
      }]);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  useEffect(() => {
    if (!showContactForm && !showPriceCalculator && inputRef.current) {
      inputRef.current.focus();
    }
  }, [showContactForm, showPriceCalculator]);

  useEffect(() => {
    const fetchFAQ = async () => {
      try {
        const response = await fetch(`${API_URL}/faq`);
        const data = await response.json();
        if (data.success) {
          setFaqItems(data.faq);
        }
      } catch (error) {
        console.error("Failed to fetch FAQ:", error);
      }
    };

    fetchFAQ();
  }, []);


  // Enhanced FAQ selection handler
  const handleFAQSelect = (question) => {
    const selected = faqItems.find(item => item.question === question);
    setAwaitingAcceptance(false);
    if (selected) {
      // Special handling for price-related questions
      if (question.includes("price") || question.includes("quote") || question.includes("cost")) {
        // Trigger the same flow as typing "price"
        setMessages(msgs => [...msgs, { from: "user", text: "price" }]);
        handleSend("price");
      } else {
        setMessages(msgs => [...msgs,
        { from: "user", text: question },
        { from: "bot", text: selected.answer }
        ]);
      }
    }
    setAwaitingAcceptance(false);
    setShowFAQ(false);
  };
  return (
    <div className="chatbot-container">
      <div className="background-image"></div>
      <button
        className="faq-button"
        onClick={() => setShowFAQ(!showFAQ)}
      >
        {showFAQ ? 'Close FAQ' : 'Browse FAQ'}
      </button>
      <div className="messages">
        {messages.map((msg, index) => (
          <div key={index} className={`message ${msg.from}`}>
            {msg.from === "bot" ? (
              <div className="bot-message">
               <img 
                    src="/mixer.png" 
                    alt="Truck Icon" 
                    className="message-icon"
                  />
                <span className="bot-name">BRM:</span>
                <div
                  className="message-content"
                  dangerouslySetInnerHTML={{ __html: msg.text }}
                />
              </div>
            ) : (
              <div className="user-message">{msg.text}</div>
            )}
          </div>
        ))}
        {isLoading}
        <div ref={messagesEndRef} />
      </div>
      {/* Enhanced FAQ Panel */}
      {showFAQ && (
        <div className="faq-panel">
          <div className="faq-header">
            <h3>Frequently Asked Questions</h3>
            <p>Select a question to get instant answers</p>
          </div>
          <div className="faq-categories">
            <div className="faq-category">
              <h4>General</h4>
              {faqItems
                .filter((item) =>
                  !['price', 'quote', 'cost', 'service', 'pump', 'inspection'].some(
                    (term) => item.question.includes(term)
                  ))
                .map((item, index) => (
                  <div
                    key={`general-${index}`}
                    className="faq-item"
                    onClick={() => handleFAQSelect(item.question)}
                  >
                    <span className="faq-icon">?</span>
                    <span className="faq-question">{item.question}</span>
                  </div>
                ))}
            </div>

            <div className="faq-category">
              <h4>Services & Pricing</h4>
              {faqItems
                .filter((item) =>
                  ['price', 'quote', 'cost', 'service', 'pump', 'inspection'].some(
                    (term) => item.question.includes(term)
                  ))
                .map((item, index) => (
                  <div
                    key={`services-${index}`}
                    className="faq-item"
                    onClick={() => handleFAQSelect(item.question)}
                  >
                    <span className="faq-icon">?</span>
                    <span className="faq-question">{item.question}</span>
                  </div>
                ))}
            </div>
          </div>
        </div>
      )}


        
      {showPriceCalculator ? (
        <div className="price-calculator">
          <h3>Concrete Price Calculator</h3>

          <div className="form-group">
            <label>Delivery Address (South Africa):</label>
            <LoadScript
              googleMapsApiKey={GOOGLE_MAPS_API_KEY}
              libraries={['places']}
              onLoad={() => {
                console.log("Google Maps API loaded");
                setMapLoaded(true);
              }}
              onError={(error) => {
                console.error("Error loading Google Maps API:", error);
                setMapLoaded(false);
              }}
            >
              {mapLoaded ? (
                <Autocomplete
                  onLoad={(autocomplete) => {
                    console.log("Autocomplete loaded");
                    setAutocomplete(autocomplete);
                  }}
                  onPlaceChanged={onPlaceChanged}
                  options={{
                    types: ['address'],
                    componentRestrictions: { country: 'za' },
                    fields: ['formatted_address', 'geometry.location']
                  }}
                >
                  <input
                    type="text"
                    placeholder="Start typing address or building name (e.g., Sandton City or 123 Main St)"
                    value={addressInput}
                    onChange={(e) => setAddressInput(e.target.value)}
                    className="address-input"
                  />
                </Autocomplete>
              ) : (
                <div className="map-loading-state">
                  {mapLoaded === false && (
                    <p>Unable to load address services. Please refresh the page.</p>
                  )}
                  <input
                    type="text"
                    placeholder="Loading address services..."
                    disabled
                  />
                </div>
              )}
            </LoadScript>
          </div>

          <div className="form-group">
            <label>Batch Plant nearest to you:</label>
            <select
              value={calculation.site}
              onChange={(e) => setCalculation({ ...calculation, site: e.target.value })}
              disabled={!!calculation.deliveryAddress}
            >
              {siteOptions.map(site => (
                <option key={site.id} value={site.id}>
                  {site.name}
                  {calculation.site === site.id && calculation.deliveryAddress && " (Nearest)"}
                </option>
              ))}
            </select>
            {calculation.deliveryAddress && (
              <p className="site-note">Automatically selected nearest site based on your address</p>
            )}
          </div>

          <div className="form-group">
            <label>Strength:</label>
            <select
              value={calculation.strength}
              onChange={(e) => setCalculation({ ...calculation, strength: e.target.value })}
            >
              {strengthOptions.map(option => (
                <option key={option} value={option}>{option}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Type:</label>
            <select
              value={calculation.type}
              onChange={(e) => {
                const newType = e.target.value;
                setCalculation(prev => ({
                  ...prev,
                  type: newType,
                  // Only auto-set needsPump to false if switching from Pumpable to Standard
                  needsPump: newType === "Pumpable" ? prev.needsPump : false
                }));
              }}
            >
              {concreteTypes.map(type => (
                <option key={type} value={type}>{type}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Need pump?</label>
            <div className="radio-group">
              <label className="radio-option">
                <input
                  type="radio"
                  name="calculatorPump"
                  checked={calculation.needsPump === true}
                  onChange={() => {
                    console.log('Pump selected: Yes');
                    setCalculation(prev => ({
                      ...prev,
                      needsPump: true,
                      type: "Pumpable" // Force type to Pumpable
                    }));
                  }}
                  disabled={calculation.type !== "Pumpable"}
                />
                Yes
              </label>
              <label className="radio-option">
                <input
                  type="radio"
                  name="calculatorPump"
                  checked={calculation.needsPump === false}
                  onChange={() => {
                    console.log('Pump selected: No');
                    setCalculation(prev => ({
                      ...prev,
                      needsPump: false
                    }));
                  }}
                />
                No
              </label>
            </div>
            {calculation.needsPump && (
              <p className="info-note">
                Pump selected: Includes establishment fee + per m³ charge
              </p>
            )}
          </div>

          <div className="form-group">
            <label>Quantity (m³):</label>
            <input
              type="number"
              min="1"
              step="0.5"
              value={calculation.quantity}
              onChange={(e) => setCalculation({ ...calculation, quantity: e.target.value })}
            />
          </div>

          <div className="form-buttons">
            <button
              className="submit-button"
              onClick={handleAddressSubmit}
              disabled={isCalculating || !calculation.deliveryAddress}
            >
              {isCalculating ? "Calculating..." : "Calculate & Quote"}
            </button>

            {/* <button
              className="secondary"
              onClick={() => {
                setShowPriceCalculator(false);
                setShowContactForm(true);
              }}
            >
              Request Quote
            </button> */}

            <button
              className="cancel-button"
              onClick={() => setShowPriceCalculator(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      ) : showContactForm ? (
        <ContactForm
          contact={contact}
          setContact={setContact}
          isCompany={isCompany}
          setIsCompany={setIsCompany}
          strengthOptions={strengthOptions}
          concreteTypes={concreteTypes}
          siteOptions={siteOptions}
          fromCalculator={true}
          onCancel={() => setShowContactForm(false)}
          onSubmit={() => handleSend("Submitted contact form")}
        />
      ) : (
        <div className="input-area">
          <input
            ref={inputRef}
            type="text"
            placeholder="Type your message..."
            onKeyDown={(e) => {
              if (e.key === "Enter" && e.target.value.trim()) {
                handleSend(e.target.value.trim());
                e.target.value = "";
              }
            }}
          />
          <button onClick={() => {
            if (inputRef.current.value.trim()) {
              handleSend(inputRef.current.value.trim());
              inputRef.current.value = "";
            }
          }}>
            Send
          </button>
        </div>
      )}

      {contact.deliveryDistance > 0 && (
        <div className="delivery-info">
          <p>

            <strong>Distance:</strong> {contact.deliveryDistance?.toFixed?.(2) || '0'} km<br />
            <strong>Delivery Fee:</strong> R{contact.deliveryFee?.toFixed?.(2) || '0.00'}
          </p>
        </div>
      )}
    </div>
  );
}

function ContactForm({
  contact,
  setContact,
  isCompany,
  setIsCompany,
  strengthOptions,
  concreteTypes,
  siteOptions,
  fromCalculator,
  onCancel,
  onSubmit
}) {

  // Enforce Pumpable type when pump is needed
  useEffect(() => {
    if (contact.needsPump && contact.concreteType !== "Pumpable") {
      setContact(prev => ({
        ...prev,
        concreteType: "Pumpable"
      }));
    }
  }, [contact.needsPump, contact.concreteType, setContact]);
  const handleNext = () => {
    // Simple validation
    if (!contact.firstName || !contact.surname || !contact.email || !contact.whatsapp) {
      alert("Please fill in all required fields: First Name, Surname, Email, and WhatsApp.");
      return;
    }

    // Proceed to calculator
    onSubmit(); // Triggers handleSend("Submitted contact form")
  };

  return (
    <div className='quote-form-container' >
      <h3>Quote Request</h3>

      <div className="user-type-selector">
        <button
          className={`type-button ${!isCompany ? 'active' : ''}`}
          onClick={() => setIsCompany(false)}
        >
          Individual
        </button>
        <button
          className={`type-button ${isCompany ? 'active' : ''}`}
          onClick={() => setIsCompany(true)}
        >
          Company
        </button>
      </div>

      {isCompany && (
        <>
          <h4>Company Information</h4>
          <input
            type="text"
            placeholder="Company Name *"
            value={contact.companyName}
            onChange={(e) => setContact({ ...contact, companyName: e.target.value })}
            required
          />
          <input
            type="text"
            placeholder="VAT Number"
            value={contact.companyRegNumber}
            onChange={(e) => setContact({ ...contact, companyRegNumber: e.target.value })}
          />
        </>
      )}

      <input
        type="text"
        placeholder="First Name *"
        value={contact.firstName}
        onChange={(e) => setContact({ ...contact, firstName: e.target.value })}
        required
      />
      <input
        type="text"
        placeholder="Surname *"
        value={contact.surname}
        onChange={(e) => setContact({ ...contact, surname: e.target.value })}
        required
      />
      <input className="form-group"
        type="email"
        placeholder="Email *"
        value={contact.email}
        onChange={(e) => setContact({ ...contact, email: e.target.value })}
        required
      />
      <input className="form-group"
        type="tel"
        placeholder="WhatsApp *"
        value={contact.whatsapp}
        onChange={(e) => setContact({ ...contact, whatsapp: e.target.value })}
        required
      />

      {/* <h4>Concrete Specifications</h4> */}
      {/* <div className="form-group">
        <label>Strength:</label>
        <select
          value={contact.strength}
          onChange={(e) => setContact({ ...contact, strength: e.target.value })}
          disabled={fromCalculator}
        >
          {strengthOptions.map(option => (
            <option key={option} value={option}>{option}</option>
          ))}
        </select>
      </div> */}

      {/* <div className="form-group">
        <label>Site:</label>
        <select
          value={contact.site}
          onChange={(e) => setContact({ ...contact, site: e.target.value })}
          disabled={fromCalculator}
        >
          {siteOptions.map(site => (
            <option key={site.id} value={site.id}>
              {site.name}
            </option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label>Type:</label>
        <div className="radio-group">
          {concreteTypes.map(type => (
            <label key={type} className="radio-option">
              <input
                type="radio"
                name="concreteType"
                value={type}
                checked={contact.concreteType === type}
                onChange={() => setContact(prev => ({
                  ...prev,
                  concreteType: type,
                  // Reset needsPump if switching to Standard
                  needsPump: type === "Pumpable" ? prev.needsPump : false
                }))}
                disabled={fromCalculator}
              />
              {type}
            </label>
          ))}
        </div>
      </div> */}

      {/* {contact.concreteType === "Pumpable" && (
        <div className="form-group">
          <label>Need pump?</label>
          <div className="radio-group">
            <label className="radio-option">
              <input
                type="radio"
                name="needsPump"
                value="yes"
                checked={contact.needsPump === true}
                onChange={() => {
                  setContact(prev => ({
                    ...prev,
                    needsPump: true,
                    concreteType: "Pumpable" // Force type to Pumpable
                  }));
                  // eslint-disable-next-line no-undef
                  setMessages(msgs => [...msgs, {
                    from: "bot",
                    text: "Pump selected: Note that pump has an establishment fee plus a per cubic meter charge."
                  }]);
                }}
                disabled={fromCalculator && contact.concreteType !== "Pumpable"}
              />
              Yes
            </label>
            <label className="radio-option">
              <input
                type="radio"
                name="needsPump"
                value="no"
                checked={contact.needsPump === false}
                onChange={() => setContact(prev => ({
                  ...prev,
                  needsPump: false
                }))}
              />
              No
            </label>
          </div>
          {contact.needsPump && (
            <p className="info-note">
              Pumping fees include a once-off establishment fee plus a per cubic meter charge.
            </p>
          )}
        </div>
      )}

      <h4>Project Details</h4>
      <textarea
        placeholder="Describe your project..."
        value={contact.projectDetails}
        onChange={(e) => setContact({ ...contact, projectDetails: e.target.value })}
      /> */}

      <div className="form-buttons">
        <button className="submit-button" onClick={handleNext}>
          Next
        </button>
        <button className="cancel-button" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </div>
  );
}